<template>
  <div class="insurance-split-order-manage">
    <el-card>
      <div class="filter-container">
        <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="95px">
          <el-form-item label="充值交易号" prop="rechargeTradeNo">
            <el-input v-model="queryParams.rechargeTradeNo" placeholder="请输入充值交易号" clearable style="width: 200px;" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="分账单号" prop="outOrderNo">
            <el-input v-model="queryParams.outOrderNo" placeholder="请输入保险分账单号" clearable style="width: 200px;" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="支付渠道" prop="payChannel">
            <el-select v-model="queryParams.payChannel" placeholder="请选择" clearable style="width: 140px;">
              <el-option label="微信" :value="1"></el-option>
              <el-option label="银联" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分账状态" prop="splitStatus">
            <el-select v-model="queryParams.splitStatus" placeholder="请选择" clearable style="width: 140px;">
              <el-option v-for="item in splitStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通知状态" prop="notifyStatus">
            <el-select v-model="queryParams.notifyStatus" placeholder="请选择" clearable style="width: 140px;">
              <el-option v-for="item in notifyStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运营商" prop="distributorName">
            <el-input v-model="queryParams.distributorName" placeholder="请输入运营商" clearable style="width: 180px;" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker v-model="dateRange" style="width: 240px" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            <el-button type="warning" icon="el-icon-s-finance" @click="handleBatchSplit" :disabled="multiple">批量分账</el-button>
            <el-button type="success" icon="el-icon-position" @click="handleBatchReNotify" :disabled="multiple">批量推送</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table v-loading="loading" :data="orderList" @selection-change="handleSelectionChange" border stripe>
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column type="index" width="60" align="center" />
        <el-table-column label="充值交易号" prop="rechargeTradeNo" show-overflow-tooltip />
        <el-table-column label="保险分账单号" prop="outOrderNo" width="160" show-overflow-tooltip />
        <el-table-column label="支付渠道" prop="payChannel" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.payChannel === 1 ? 'success' : 'warning'" size="small">{{ getPayChannelText(scope.row.payChannel) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="运营商" prop="distributorName" width="140" show-overflow-tooltip />
        <el-table-column label="车辆类型" prop="deviceTypeCode" width="100">
          <template slot-scope="scope">{{ getDeviceTypeName(scope.row.deviceTypeCode) }}</template>
        </el-table-column>
        <el-table-column label="保险金额" prop="insuranceAmount" width="100" align="center">
          <template slot-scope="scope">{{ formatAmount(scope.row.insuranceAmount) }}</template>
        </el-table-column>
        <el-table-column label="分账金额" prop="splitTotalAmount" width="100" align="center">
          <template slot-scope="scope">{{ formatAmount(scope.row.splitTotalAmount) }}</template>
        </el-table-column>
        <el-table-column label="分账状态" prop="splitStatus" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getSplitStatusType(scope.row.splitStatus)" size="small">{{ getSplitStatusText(scope.row.splitStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="通知状态" prop="notifyStatus" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getNotifyStatusType(scope.row.notifyStatus)" size="small">{{ getNotifyStatusText(scope.row.notifyStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="渠道支付单号" prop="channelTransactionId" width="180" show-overflow-tooltip />
        <el-table-column label="渠道分账单号" prop="channelSplitOrderNo" width="180" show-overflow-tooltip />
        <el-table-column label="失败原因" prop="failReason" show-overflow-tooltip />
        <el-table-column label="创建时间" prop="createTime" width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="250" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-view" @click="handleDetail(scope.row)">详情</el-button>
            <el-button
              size="mini"
              :type="scope.row.splitStatus === 1 ? 'info' : 'warning'"
              icon="el-icon-s-finance"
              @click="handleSplit(scope.row)"
              :disabled="scope.row.splitStatus === 1"
            >分账</el-button>
            <el-button
              size="mini"
              :type="scope.row.notifyStatus === 1 ? 'info' : 'success'"
              icon="el-icon-position"
              @click="handleReNotify(scope.row)"
              :disabled="scope.row.splitStatus !== 1 || scope.row.notifyStatus === 1"
            >推送</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.page" :page-sizes="[10, 20, 30, 50]" :page-size="queryParams.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </el-card>

    <el-dialog title="保险分账记录详情" :visible.sync="detailOpen" width="950px" append-to-body>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="记录ID">{{ detailForm.id }}</el-descriptions-item>
        <el-descriptions-item label="保险订单ID">{{ detailForm.insuranceOrderId }}</el-descriptions-item>
        <el-descriptions-item label="充值交易号">{{ detailForm.rechargeTradeNo }}</el-descriptions-item>
        <el-descriptions-item label="保险分账单号">{{ detailForm.outOrderNo }}</el-descriptions-item>
        <el-descriptions-item label="支付渠道">{{ getPayChannelText(detailForm.payChannel) }}</el-descriptions-item>
        <el-descriptions-item label="渠道支付单号">{{ detailForm.channelTransactionId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="渠道分账单号">{{ detailForm.channelSplitOrderNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="运营商">{{ detailForm.distributorName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="保险金额">{{ formatAmount(detailForm.insuranceAmount) }}</el-descriptions-item>
        <el-descriptions-item label="分账金额">{{ formatAmount(detailForm.splitTotalAmount) }}</el-descriptions-item>
        <el-descriptions-item label="分账状态">{{ getSplitStatusText(detailForm.splitStatus) }}</el-descriptions-item>
        <el-descriptions-item label="通知状态">{{ getNotifyStatusText(detailForm.notifyStatus) }}</el-descriptions-item>
        <el-descriptions-item label="失败原因" :span="2">{{ detailForm.failReason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="渠道响应" :span="2">{{ detailForm.channelResponse || '-' }}</el-descriptions-item>
      </el-descriptions>

      <el-divider content-position="left">分账明细</el-divider>
      <el-table :data="detailList" border stripe>
        <el-table-column label="接收方类型" prop="receiverType" width="110" align="center">
          <template slot-scope="scope">{{ getReceiverTypeText(scope.row.receiverType) }}</template>
        </el-table-column>
        <el-table-column label="接收方账号" prop="receiverAccount" show-overflow-tooltip />
        <el-table-column label="接收方名称" prop="receiverName" show-overflow-tooltip />
        <el-table-column label="分账金额" prop="splitAmount" width="100" align="center">
          <template slot-scope="scope">{{ formatAmount(scope.row.splitAmount) }}</template>
        </el-table-column>
        <el-table-column label="分账状态" prop="splitStatus" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getSplitStatusType(scope.row.splitStatus)" size="small">{{ getSplitStatusText(scope.row.splitStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="渠道明细号" prop="channelDetailNo" show-overflow-tooltip />
        <el-table-column label="失败原因" prop="failReason" show-overflow-tooltip />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailOpen = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'InsuranceSplitOrderManage',
  data() {
    return {
      loading: false,
      total: 0,
      orderList: [],
      ids: [],
      multiple: true,
      detailOpen: false,
      detailForm: {},
      detailList: [],
      dateRange: [],
      deviceTypeList: [],
      queryParams: {
        page: 1,
        limit: 10,
        rechargeTradeNo: null,
        outOrderNo: null,
        payChannel: null,
        splitStatus: null,
        notifyStatus: null,
        distributorName: null
      },
      splitStatusOptions: [
        { label: '待分账', value: 0 },
        { label: '分账成功', value: 1 },
        { label: '分账失败', value: 2 }
      ],
      notifyStatusOptions: [
        { label: '未通知', value: 0 },
        { label: '通知成功', value: 1 },
        { label: '通知失败', value: 2 }
      ]
    }
  },
  created() {
    this.getDeviceTypeList()
    this.getList()
  },
  methods: {
    getDeviceTypeList() {
      this.$http.get('/device/typeConfig/getAllList').then(res => {
        if (res.data.code === 200) {
          this.deviceTypeList = res.data.data || []
        }
      })
    },
    getDeviceTypeName(deviceTypeCode) {
      const item = this.deviceTypeList.find(d => d.deviceTypeCode === deviceTypeCode)
      return item ? item.deviceTypeName : (deviceTypeCode || '-')
    },
    async getList() {
      this.loading = true
      try {
        const { data: res } = await this.$http.post('/insurance/split/order/page', this.addDateRange(this.queryParams, this.dateRange))
        if (res.code !== 200) return this.$message.error(res.msg || '获取数据失败')
        this.orderList = res.data.list || []
        this.total = res.data.total || 0
      } finally {
        this.loading = false
      }
    },
    async handleDetail(row) {
      this.detailForm = { ...row }
      this.detailList = []
      const { data: res } = await this.$http.get('/insurance/split/order/' + row.id + '/details')
      if (res.code === 200) {
        this.detailList = res.data || []
      } else {
        this.$message.error(res.msg || '获取分账明细失败')
      }
      this.detailOpen = true
    },
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    resetQuery() {
      this.dateRange = []
      this.$refs.queryForm && this.$refs.queryForm.resetFields()
      this.handleQuery()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.multiple = !selection.length
    },
    handleSplit(row) {
      if (row.splitStatus === 1) {
        this.$message.warning('该分账记录已成功')
        return
      }
      this.$confirm('确认要对该骑行险分账记录执行手动分账吗？分账单号：' + row.outOrderNo + '，保险金额：' + this.formatAmount(row.insuranceAmount), '分账确认', {
        confirmButtonText: '确认分账',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http.post('/insurance/split/order/manual/' + row.id).then(response => {
          this.loading = false
          if (response.data.code === 200) {
            this.$message.success('分账请求已提交，请稍后刷新查看结果')
            this.getList()
          } else {
            this.$message.error(response.data.msg || '分账失败')
          }
        }).catch(() => {
          this.loading = false
          this.$message.error('分账请求失败')
        })
      }).catch(() => {})
    },
    handleBatchSplit() {
      const selectedRows = this.orderList.filter(item => this.ids.includes(item.id))
      const cannotSplit = selectedRows.filter(item => item.splitStatus === 1)
      if (cannotSplit.length > 0) {
        this.$message.warning('已选中的记录中有' + cannotSplit.length + '条已分账成功，请重新选择')
        return
      }
      this.$confirm('确认要对选中的 ' + this.ids.length + ' 条记录执行批量分账吗？', '批量分账确认', {
        confirmButtonText: '确认分账',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http.post('/insurance/split/order/batch/manual', this.ids).then(response => {
          this.loading = false
          if (response.data.code === 200) {
            this.$message.success('批量分账完成，成功：' + (response.data.data.successCount || 0) + ' 条，失败：' + (response.data.data.failCount || 0) + ' 条')
            this.getList()
          } else {
            this.$message.error(response.data.msg || '批量分账失败')
          }
        }).catch(() => {
          this.loading = false
          this.$message.error('批量分账请求失败')
        })
      }).catch(() => {})
    },
    handleReNotify(row) {
      if (row.splitStatus !== 1) {
        this.$message.warning('仅分账成功的记录才能推送结果')
        return
      }
      if (row.notifyStatus === 1) {
        this.$message.warning('该记录已通知成功，无需重复推送')
        return
      }
      this.$confirm('确认要重新推送该分账结果到保险平台吗？分账单号：' + row.outOrderNo, '推送确认', {
        confirmButtonText: '确认推送',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http.post('/insurance/split/order/reNotify/' + row.id).then(response => {
          this.loading = false
          if (response.data.code === 200) {
            this.$message.success('推送成功')
            this.getList()
          } else {
            this.$message.error(response.data.msg || '推送失败')
          }
        }).catch(() => {
          this.loading = false
          this.$message.error('推送请求失败')
        })
      }).catch(() => {})
    },
    handleBatchReNotify() {
      const selectedRows = this.orderList.filter(item => this.ids.includes(item.id))
      const cannotNotify = selectedRows.filter(item => item.splitStatus !== 1 || item.notifyStatus === 1)
      if (cannotNotify.length > 0) {
        this.$message.warning('已选中的记录中有' + cannotNotify.length + '条不满足推送条件（需分账成功且未通知成功），请重新选择')
        return
      }
      this.$confirm('确认要对选中的 ' + this.ids.length + ' 条记录批量推送分账结果到保险平台吗？', '批量推送确认', {
        confirmButtonText: '确认推送',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http.post('/insurance/split/order/batch/reNotify', this.ids).then(response => {
          this.loading = false
          if (response.data.code === 200) {
            this.$message.success('批量推送完成，成功：' + (response.data.data.successCount || 0) + ' 条，失败：' + (response.data.data.failCount || 0) + ' 条')
            this.getList()
          } else {
            this.$message.error(response.data.msg || '批量推送失败')
          }
        }).catch(() => {
          this.loading = false
          this.$message.error('批量推送请求失败')
        })
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.queryParams.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    addDateRange(params, dateRange) {
      const search = { ...params, beginTime: '', endTime: '' }
      if (dateRange && dateRange.length === 2) {
        search.beginTime = dateRange[0]
        search.endTime = dateRange[1]
      }
      return search
    },
    formatAmount(value) {
      const num = parseFloat(value)
      return isNaN(num) ? '-' : '¥' + num.toFixed(2)
    },
    formatTime(time) {
      if (!time) return '-'
      return String(time).replace('T', ' ')
    },
    getPayChannelText(value) {
      return value === 1 ? '微信' : value === 2 ? '银联' : '-'
    },
    getSplitStatusText(value) {
      const item = this.splitStatusOptions.find(item => item.value === value)
      return item ? item.label : '-'
    },
    getSplitStatusType(value) {
      return value === 1 ? 'success' : value === 2 ? 'danger' : 'info'
    },
    getNotifyStatusText(value) {
      const item = this.notifyStatusOptions.find(item => item.value === value)
      return item ? item.label : '-'
    },
    getNotifyStatusType(value) {
      return value === 1 ? 'success' : value === 2 ? 'danger' : 'info'
    },
    getReceiverTypeText(value) {
      return value === 1 ? '保险公司' : value === 2 ? '商户' : value === 3 ? '平台' : '-'
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}
</style>
